import React from 'react';
import styled from 'styled-components';
import { Edit2 } from '@finect/tabular-icons/edit-2';
export var EditAction = styled.span.withConfig({
  displayName: "EditableCell__EditAction",
  componentId: "sc-1czu6gr-0"
})(["margin-left:4px;cursor:pointer;vertical-align:middle;&:hover{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
export var EditableCell = function EditableCell(_ref2) {
  var children = _ref2.children,
    onAction = _ref2.onAction;
  var handleAction = function handleAction() {
    onAction();
  };
  return React.createElement("div", null, children, React.createElement(EditAction, {
    role: "button",
    onClick: handleAction
  }, React.createElement(Edit2, {
    size: "16px"
  })));
};